module.exports = __webpack_public_path__ + "img/chofu_event_off.b7048468.svg";